import React, {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {Tabs} from "@mui/material";
import {useSelector} from "react-redux";
import {getArticles} from "modules/selectors";
import {IPlayer} from "modules/types";
import {DetailsModalTabs} from "modules/enums";
import {getTeamFieldHasNews} from "modules/utils";
import {PlayerOverview} from "./PlayerOverview";
import {TabPanelWrapper, TabStyled, Wrapper} from "./common";
import {PlayerNews} from "./News";

interface ITabPanel {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: ITabPanel) {
	const {children, value, index} = props;

	return (
		<TabPanelWrapper role="tabpanel" hidden={value !== index}>
			{value === index && children}
		</TabPanelWrapper>
	);
}

interface IModalTabs {
	player: IPlayer;
	activeTab: DetailsModalTabs;
	onTabChange: (tab: number) => void;
}

export const PlayerTabs: React.FC<IModalTabs> = ({player, activeTab, onTabChange}) => {
	const {t, i18n} = useTranslation();
	const lang = i18n.language;
	const articles = useSelector(getArticles);
	const playerHasNews = getTeamFieldHasNews(articles, player, lang);

	const handleChange = useCallback(
		(event: React.SyntheticEvent, newValue: number) => {
			onTabChange(newValue);
		},
		[onTabChange]
	);

	return (
		<Wrapper>
			<Tabs value={activeTab} onChange={handleChange}>
				<TabStyled label={t("player_profiles.tab.overview")} value={0} />

				{playerHasNews && (
					<TabStyled label={t("player_profiles.tab.news.title")} value={1} />
				)}
			</Tabs>

			<TabPanel value={activeTab} index={0}>
				<PlayerOverview player={player} />
			</TabPanel>

			{playerHasNews && (
				<TabPanel value={activeTab} index={1}>
					<PlayerNews player={player} />
				</TabPanel>
			)}
		</Wrapper>
	);
};
